module.exports = __webpack_public_path__ + "static/map-6c715f288863dba01275ede37dbe7c78.png";